export enum PaymentPlatform {
  PayPal = 'PayPal',
  PayPalV2 = 'PayPalV2',
  Stripe = 'Stripe',
  Apple = 'Apple',
  Google = 'Google'
}



// WEBPACK FOOTER //
// ./src/app/paymentTransactions/models/PaymentPlatform.ts